import React from 'react';
import { Plus, X } from 'lucide-react';
import Combobox from './Combobox';

function normalizeRows(value) {
  if (!Array.isArray(value)) return [];
  return value.map((item) => {
    if (typeof item === 'string') {
      return { name: item, role: '' };
    }
    if (!item || typeof item !== 'object') {
      return { name: '', role: '' };
    }
    return {
      name: item.name || item.counterparty || item.party || '',
      role: item.role || item.relationship || item.type || '',
    };
  });
}

export default function AdditionalCounterpartiesEditor({
  value,
  onChange,
  counterpartyOptions = [],
  label = 'Additional Counterparties',
  hint = 'Other non-Lightspark legal parties on the agreement, such as guarantors, affiliates, parents, or extra signatories.',
}) {
  const rows = normalizeRows(value);

  const updateRow = (index, patch) => {
    onChange(rows.map((row, i) => (i === index ? { ...row, ...patch } : row)));
  };

  const removeRow = (index) => {
    onChange(rows.filter((_, i) => i !== index));
  };

  const addRow = () => {
    onChange([...rows, { name: '', role: '' }]);
  };

  return (
    <div>
      <div className="field-label">{label}</div>
      <div
        style={{
          border: 'var(--stroke-xs) solid var(--border-primary)',
          borderRadius: 'var(--corner-radius-md)',
          padding: 10,
          background: 'var(--surface-primary)',
        }}
      >
        {rows.length === 0 ? (
          <div className="muted" style={{ fontSize: 12, marginBottom: 8 }}>
            No additional parties.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 10 }}>
            {rows.map((row, index) => (
              <div key={index} className="party-row">
                <Combobox
                  value={row.name}
                  onChange={(name) => updateRow(index, { name })}
                  options={counterpartyOptions}
                  placeholder="Legal party name"
                  emptyHint={row.name ? 'No match - this will create a new counterparty.' : null}
                  inputProps={{ 'aria-label': `Additional counterparty ${index + 1} name` }}
                />
                <input
                  className="input"
                  value={row.role}
                  onChange={(e) => updateRow(index, { role: e.target.value })}
                  placeholder="Role"
                  aria-label={`Additional counterparty ${index + 1} role`}
                />
                <button
                  type="button"
                  className="icon-btn sm"
                  onClick={() => removeRow(index)}
                  title="Remove party"
                  aria-label={`Remove additional counterparty ${index + 1}`}
                >
                  <X className="w-3.5 h-3.5" />
                </button>
              </div>
            ))}
          </div>
        )}
        <button type="button" className="btn outline xs" onClick={addRow}>
          <Plus className="w-3 h-3" /> Add party
        </button>
      </div>
      {hint && <div className="field-hint">{hint}</div>}
    </div>
  );
}
